const Terra_Coin = require("./contracts/TerraCoin.json");
const Insurance = require("./contracts/Insurance.json");

const Constants = {
	// TerraCoin_address: Terra_Coin.networks["42"].address,
	// Insurance_address: Insurance.networks["42"].address,
};
export default Constants;
